import { render } from "./shorts_master.vue?vue&type=template&id=c72d9180&scoped=true"
import script from "./shorts_master.vue?vue&type=script&lang=js"
export * from "./shorts_master.vue?vue&type=script&lang=js"

import "./shorts_master.vue?vue&type=style&index=0&id=c72d9180&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72d9180"]])

export default __exports__